<div class="p-3 p-md-0">

  <div *ngIf="profileDetail?.applicationStatus === this.eApplicationStatus.CANCELLED" class="row justify-content-center">
    <div class="alert alert-danger col-md-8 col-sm-12 pt-0 pb-0" style="border-radius: 35px !important; ">
      <div class="row justify-content-between">
        <div class="col-1 text-left align-content-center" >
          <i class="fa fa-lg text-danger fa-exclamation-circle"></i>
        </div>
        <div class="col-11 text-left translate-new-line">
          <p>
            <span style="font-size: medium">{{'accounts.balance.notifications.application_cancelled' | translate: {callCenter:this.configuration.callCenterNumber} }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="profileDetail?.mediaAccessStatus === this.eMediaAccessStatus.INACTIVE" class="row justify-content-center">
    <div class="alert alert-warning col-md-8 col-sm-12 pt-0 pb-0" style="border-radius: 35px !important; ">
      <div class="row justify-content-between">
        <div class="col-1 text-left align-content-center" >
          <i class="fa fa-lg text-warning fa-exclamation-triangle"></i>
        </div>
        <div class="col-11 text-left translate-new-line">
          <p>
            <span style="font-size: medium">{{'accounts.balance.notifications.media_access_inactive' | translate: {callCenter:this.configuration.callCenterNumber} }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="profileDetail?.mediaAccessStatus === this.eMediaAccessStatus.BLOCKED" class="row justify-content-center">
    <div class="alert alert-danger col-md-8 col-sm-12 pt-0 pb-0" style="border-radius: 35px !important; ">
      <div class="row justify-content-between">
        <div class="col-1 text-left align-content-center" >
          <i class="fa fa-lg text-danger fa-exclamation-circle"></i>
        </div>
        <div class="col-11 text-left translate-new-line">
          <p>
            <span style="font-size: medium">{{'accounts.balance.notifications.media_access_blocked' | translate: {callCenter:this.configuration.callCenterNumber} }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="profileDetail?.mediaAccessStatus === this.eMediaAccessStatus.CANCELLED" class="row justify-content-center">
    <div class="alert alert-danger col-md-8 col-sm-12 pt-0 pb-0" style="border-radius: 35px !important; ">
      <div class="row justify-content-between">
        <div class="col-1 text-left align-content-center" >
          <i class="fa fa-lg text-danger fa-exclamation-circle"></i>
        </div>
        <div class="col-11 text-left translate-new-line">
          <p>
            <span style="font-size: medium">{{'accounts.balance.notifications.media_access_cancelled' | translate: {callCenter:this.configuration.callCenterNumber} }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="profileDetail?.mediaAccessStatus === this.eMediaAccessStatus.LOCKED" class="row justify-content-center">
    <div class="alert alert-info col-md-8 col-sm-12 pt-0 pb-0" style="border-radius: 35px !important;">
      <div class="row justify-content-between">
        <div class="col-1 text-left align-content-center" >
          <i class="fa fa-lg text-info fa-info-circle"></i>
        </div>
        <div class="col-11 text-left translate-new-line">
          <p>
            <span *ngIf="this.configuration.hasCardBlocking" style="font-size: medium">{{'accounts.balance.notifications.media_access_locked' | translate }}</span>
            <span *ngIf="!this.configuration.hasCardBlocking" style="font-size: medium">{{'accounts.balance.notifications.media_access_locked_call' | translate }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>



  <div *ngIf="profileDetail?.applicationStatus === this.eApplicationStatus.SUBMITTED" class="row justify-content-center">
    <div class="alert alert-info col-md-8 col-sm-12 pt-0 pb-0" style="border-radius: 35px !important; ">
      <div class="row justify-content-between">
        <div class="col-1 text-left align-content-center" >
          <i class="fa fa-lg text-info fa-info-circle"></i>
        </div>
        <div class="col-11 text-left translate-new-line">
          <p>
            <span style="font-size: medium">{{'accounts.balance.notifications.application_submitted' | translate: {time:this.configuration.verificationProcessTime} }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="this.configuration.enableFamilyHealth &&
      this.profileDetail.applicationStatus == eApplicationStatus.APPROVED &&
      this.profileDetail.customerStatus == eCustomerStatus.ACTIVE &&
      (this.profileDetail.healthSubscriptionStatus == eFamilyHealthStatus.NOT_CREATED ||
      this.profileDetail.healthSubscriptionStatus == eFamilyHealthStatus.CANCELLED) &&
      !this.familyHealthService.consulted" class="row justify-content-center" (click)="openModal(modal_bahuPortals); webPage = familyHealthService.url;">
    <div class="alert alert-info col-md-8 col-sm-12" style="border-radius: 35px !important; cursor: pointer; ">
      <div class="row justify-content-between">
        <div class="col-2 text-left " >
          <img src="assets/logos/logo_family_card_health.png" class="" alt="..." id="cardImg" style="width:auto; height:50px">
        </div>
        <div class="col-10 text-left">
          <p><b style="font-size: x-large">{{"accounts.balance.notifications.family-health" | translate}}</b> <br>
            <span style="font-size: medium">{{"accounts.balance.notifications.family-health-subscribe" | translate}}</span></p>
        </div>
      </div>
    </div>
  </div>



  <div *ngIf="emailValidation" class="row justify-content-center">
    <div class="alert alert-warning col-md-8 col-sm-12 pt-0 pb-0" style="border-radius: 35px !important;">
      <div class="row justify-content-between">
        <div class="col-1 text-left align-content-center" >
          <i class="fa fa-lg text-warning fa-exclamation-triangle"></i>
        </div>
        <div class="col-11 text-left translate-new-line">
          <p>
            <b style="font-size: x-large">{{ "accounts.balance.notifications.confirm-email" | translate }}</b> <br>
            <span style="font-size: medium">{{'accounts.balance.notifications.email-not-confirmed' | translate: {email: this.profileDetail?.email} }}</span><br>
            <span style="font-size: medium">{{"accounts.balance.notifications.email-change" | translate }}</span><br>
            <span class="text-primary send-email" (click)="this.sendEmailConfirmation()" style="font-size: medium; cursor: pointer;">{{"accounts.balance.notifications.resend-confirmation" | translate }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>

</div>




<ng-template #modal_bahuPortals let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ "accounts.modal_portals.title" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ "accounts.modal_portals.privacyPolicy" | translate }}</p>
  </div>
  <div class="modal-footer">
    <div class="btn-group">
      <button type="button" class="btn btn-outline-dark" (click)="modal.close(); webPage = null">{{ "accounts.modal_portals.cancel" | translate }}</button>
      <a class="btn btn-primary" [href]="webPage" (click)="familyHealthService.consulted = true; modal.close(); " target="_blank">{{ "accounts.modal_portals.accept" | translate }}</a>
    </div>
  </div>
</ng-template>